<template>
    <b-button
        variant="primary"
        @click.stop="confirmarSalvar()"
        class="ml-1"
    >
        <span>
            <i class="fa fa-clone mr-2"></i>
            Obter dados do RM
        </span>
  </b-button>
</template>

<script>
import ContratosServicos from './ContratosServicos'

export default {
    props: {
        contrato: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmarSalvar() {
            this.$swal({
                title: 'Contratos',
                html: `Confirma a sincronização do contrato <b>${
                    this.contrato.vcCodigoEstruturado
                }</b> com o contrato <b>${
                    this.contrato.contratoRM
                }</b> do RM?
                <br/><br/><div class="alert alert-danger" role="alert">
                    Atenção! Essa é uma operação irreversível!
                </div>`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.obterDadosRM()
                }
            })
        },

        obterDadosRM(){
            this.$store.dispatch('addRequest')
            ContratosServicos.obterDadosRM(this.contrato.idContrato).then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Dados sincronizados com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$emit('obterContratoAtualizado')
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })

            this.$emit('obterContratoAtualizado')
        }
    }
}
</script>

<style>

</style>